import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export function IconTruckNotCollected({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      fill="none"
      viewBox="3 4.8 18 14.4"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
    >
      <path
        d="M20.107 14.701v-3.226a1.8 1.8 0 0 0-.526-1.274l-2.174-2.174c-.339-.331-.792-.519-1.265-.526h-1.428V6.149a1.35 1.35 0 0 0-.395-.955 1.35 1.35 0 0 0-.955-.395H4.355a1.35 1.35 0 0 0-.958.394 1.35 1.35 0 0 0-.398.956v9.002a1.35 1.35 0 0 0 1.35 1.35h.446a2.7 2.7 0 0 0 .791 1.909 2.7 2.7 0 0 0 1.909.791 2.7 2.7 0 0 0 1.909-.791 2.7 2.7 0 0 0 .791-1.909h3.611c.02.703.314 1.37.818 1.86s1.18.764 1.883.764 1.379-.274 1.883-.764.798-1.157.818-1.86h.891a.9.9 0 0 0 .9-.9.9.9 0 0 0-.9-.9h.009zM7.505 17.86a1.35 1.35 0 0 1-1.247-.833 1.35 1.35 0 0 1 .293-1.471 1.35 1.35 0 0 1 1.471-.293 1.35 1.35 0 0 1 .833 1.247 1.35 1.35 0 0 1-1.35 1.35h0zm4.761-5.346a.75.75 0 0 1 .161.814.75.75 0 0 1-.689.462.74.74 0 0 1-.528-.223l-2.45-2.45-2.462 2.451a.74.74 0 0 1-.528.221.74.74 0 0 1-.528-.221c-.142-.138-.223-.326-.226-.524s.073-.388.21-.53l2.45-2.45-2.45-2.484c-.14-.14-.219-.33-.219-.528s.079-.388.219-.528.33-.219.528-.219.388.079.528.219l2.462 2.45 2.45-2.45a.75.75 0 0 1 1.03.029.75.75 0 0 1 .026 1.03l-2.451 2.45 2.466 2.482zm4.233 5.346a1.35 1.35 0 0 1-1.247-.833 1.35 1.35 0 0 1 .293-1.471 1.35 1.35 0 0 1 1.471-.293 1.35 1.35 0 0 1 .833 1.247 1.35 1.35 0 0 1-1.341 1.35h-.009zm1.8-5.85h-3.593V9.301h1.437l2.174 2.174-.018.535z"
        fill={color}
      />
    </svg>
  )
}
